import React, { useState, useEffect } from 'react';
import { getWebClient } from '../helpers/Helpers.js';
import SpinnerOverlay from './components/SpinnerOverlay.js';

export default function StampaAgendeBuyer() {

    const client = getWebClient();

    const [date, setDate] = useState();
    const [model, setModel] = useState();

    function dateGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/date`).then((response) => {
                resolve(response.data);
            });
        });
    }

    function agendeBuyerGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/agendebuyer`).then((response) => {
                resolve(response.data);
            });
        });
    }

    useEffect(() => {

        Promise.all([dateGetPromise(), agendeBuyerGetPromise()])

            .then((results) => {

                let dateGetPromiseResult = results[0];
                let agendeBuyerGetPromiseResult = results[1];

                setDate(dateGetPromiseResult);
                setModel(agendeBuyerGetPromiseResult);

            })

            .catch((err) => {
                console.log(err);
            });

    }, []);

    if (!model) {

        return (
            <>
                <SpinnerOverlay></SpinnerOverlay>
            </>
        );

    } else {

        debugger;

        return (
            <>

                <style
                    dangerouslySetInnerHTML={{
                        __html:
                            " html, body { margin-left: auto; margin-right: auto; margin-top: 0mm; padding: 0; width: 21cm; height: 29.7cm; } @media print { .pagina { margin-left: auto; margin-right: auto; margin-top: 0mm; padding: 0; width: 21cm; height: 29.7cm; page-break-after: always; size: A4 portrait; } } "
                    }}
                />

                {
                    model.map(function (agenda, agendaIndex) {
                        return (

                            agenda.date.map(function (data, dataIndex) {
                                return (


                                    <div className="container pagina">
                                        <center>
                                            <br></br>
                                            <h4>{agenda.ragioneSociale} - {data.data}</h4>
                                            <br></br>
                                        </center>

                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Time</th>
                                                    <th>Appointment&nbsp;with</th>
                                                    <th>Stand</th>
                                                    <th>Queued&nbsp;with</th>
                                                    <th>Stand</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            {
                                                data.appuntamenti.map(function (appuntamento, appuntamentoIndex) {
                                                    return (
                                                        <tr>
                                                            <td>{appuntamento.oraDa}-{appuntamento.oraA}</td>
                                                            <td>{appuntamento.partner ? appuntamento.partner : '-'}</td>
                                                            <td>{appuntamento.partnerStand ? appuntamento.partnerStand : '-'}</td>
                                                            <td>{appuntamento.queuedPartner ? appuntamento.queuedPartner : '-'}</td>
                                                            <td>{appuntamento.queuedPartnerStand ? appuntamento.queuedPartnerStand : '-'}</td>
                                                        </tr>
                                                    );
                                                })
                                            }

                                            </tbody>
                                        </table>
                                    </div>

                                );
                            })

                        );
                    })
                }

            </>
        );

    }

}
